import { CardBody, HoverPreviewImage, Metric, Metrics } from "common/hovercards/CardBody";
import { MountOnHoverCard } from "common/hovercards/MountOnHoverCard";
import { Distance, Elevation, Speed } from "common/units";
import { commonMetrics, Msg } from "lib/localization";
import PropTypes from "prop-types";
import React from "react";

export class SegmentMatchCard extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    distance: PropTypes.number.isRequired,
    elevationGain: PropTypes.number.isRequired,
    avgSpeed: PropTypes.number.isRequired,
  };

  render() {
    const { children, title, type, id, distance, elevationGain, avgSpeed } = this.props;

    const image = <HoverPreviewImage type={type} id={id} />;
    const content = (
      <Metrics>
        <Metric label={<Msg m={commonMetrics.distance} />} value={<Distance short value={distance} />} />
        <Metric label={<Msg m={commonMetrics.elevationGain} />} value={<Elevation short value={elevationGain} />} />
        <Metric label={<Msg m={commonMetrics.averageSpeed} />} value={<Speed short value={avgSpeed} />} />
      </Metrics>
    );

    return (
      <MountOnHoverCard wrappedChildren={children}>
        <CardBody header={title} image={image} content={content} />
      </MountOnHoverCard>
    );
  }
}
